import { immerable } from "immer";

export class CollapsedEmployeesGroups {
  [immerable] = true;

  constructor(
    public readonly sectionsIds = new Set<string>(),
    public readonly rolesIds = new Set<string>(),
  ) {}
}
